import AuthComponent from "@components/auth/component";
import DeleteButton from "@components/buttons/DeleteButton";
import EditButton from "@components/buttons/EditButton";
import { TSliderManagement } from "@type-defs/cms/TSlider";

export const sliderColumns = (deleteHandler: (id: string | number) => void) => [
  {
    name: "Slider ID",
    selector: (row: TSliderManagement) => row.slider_id,
    sort: true,
    grow: 0.5,
  },
  {
    name: "Slider Image",
    selector: (row: TSliderManagement) => (
      <img
        src={row.slider_image}
        alt={`Slider ${row.slider_id}`}
        style={{ width: "100px", height: "auto", borderRadius: "8px" }}
      />
    ),
    sortable: false, // You can’t sort images directly
  },
  {
    name: "Action(s)",
    right: "true",
    selector: (row: any) => (
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {/* <AuthComponent
          action="edit"
          module="Slider"
          subModule="Slider Management"
        >
          <EditButton
            //@ts-ignore
            id={row.slider_id}
            actionHandler={() => editHandler(row)}
          />
        </AuthComponent> */}

        <AuthComponent
          action="delete"
          module="CMS"
          subModule="Slider Management"
        >
          <DeleteButton id={row.slider_id} actionHandler={deleteHandler} />
        </AuthComponent>
      </div>
    ),
  },
];
